import { AppState } from '../types/app-state';

const NS = 'msp_auth_state';

export function loadState(): Partial<AppState> | undefined {
  try {
    const serializableState = localStorage.getItem(NS);
    if (serializableState === null) {
      return;
    }
    return JSON.parse(serializableState);
  } catch (error) {
    return;
  }
}

export function saveState(state: Partial<AppState>) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(NS, serializedState);
  } catch (error) {
    return;
  }
}

export function destroyState() {
  try {
    localStorage.removeItem(NS);
  } catch (error) {
    return;
  }
}